import React from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

class MarkdownErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <pre style={{ whiteSpace: "pre-wrap", margin: 0, fontFamily: "inherit" }}>
          {this.props.fallbackText || ""}
        </pre>
      );
    }
    return this.props.children;
  }
}

const SafeMarkdown = ({ content, components }) => (
  <MarkdownErrorBoundary fallbackText={content}>
    <Markdown remarkPlugins={[remarkGfm]} components={components}>
      {content}
    </Markdown>
  </MarkdownErrorBoundary>
);

export default SafeMarkdown;
 